import { parentType } from '../../../../constants/types/student-type';
import { StudentProfileForm } from '../../../../constants/types/student-profile-form';
import { StudentProfile } from '../../../../constants/types/student/profile/type';
import { normalizePhone } from '../../../../constants/validation';

/**
 * 학생 내 정보 화면에서 실제로 수정하는 값.
 * 폼 자체는 StudentProfileForm이지만, 이 화면은 그중 기본 정보/보호자만 다룬다.
 */
export type StudentMyInfoForm = Pick<
  StudentProfileForm,
  'englishName' | 'birthday' | 'gender' | 'parents'
>;

/**
 * 조회 응답의 보호자 목록.
 * parents가 아직 없는 응답은 최초 로그인에서 받은 guardianInfo를 목록으로 바꿔서 보여준다.
 */
const toParents = (profile: StudentProfile): parentType[] => {
  if (profile.parents?.length) {
    return profile.parents.map((parent) => ({
      name: parent.name,
      phone: parent.phone,
      parentType: parent.parentType,
      birthday: parent.birthday,
    }));
  }
  // 최초 로그인 때 만들어진 빈 guardianInfo(이름 미입력)는 등록된 보호자가 아니다.
  if (!profile.guardianInfo?.name) return [];

  const { name, phone, gender, birthday } = profile.guardianInfo;
  return [{ name, phone, parentType: gender, birthday }];
};

/** 조회 응답을 폼 값으로 바꾼다. 입력이 비어 있으면 빈 문자열로 맞춘다. */
export const toStudentMyInfoForm = (
  profile: StudentProfile,
): StudentMyInfoForm => ({
  englishName: profile.englishName ?? '',
  birthday: profile.birthday ?? '',
  gender: profile.gender ?? '',
  parents: toParents(profile),
});

/** 저장 값 정리: 연락처는 숫자만 남기고, 빈 생년월일은 미입력으로 보낸다. */
export const normalizeParents = (parents: parentType[] = []) =>
  parents.map((parent) => ({
    ...parent,
    gender: parent.parentType,
    phone: normalizePhone(parent.phone ?? ''),
    // birthday: parent.birthday || undefined,
  }));
